<template>
  <el-dialog :width="dialog.width" title="文件预览" :visible.sync="dialog.show">
    <div style="display: flex; justify-content: center; align-items: center;overflow: hidden;">
      <!-- 图片元素 -->
      <el-image ref="image" :src="dialog.url" style="height: 70vh; cursor: grab; position: relative;"
        :style="imageStyle" @mousedown="startDrag">
      </el-image>
    </div>

    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="big">放 大</el-button>
      <el-button type="primary" @click="small">缩 小</el-button>
      <el-button type="primary" @click="restore">恢 复</el-button>
      <el-button type="primary" @click="close">关 闭</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      dialog: { show: false, width: "90vw", url: "", iframe: false },
      scale: 1, // 图片的缩放比例
      isDragging: false, // 是否正在拖动
      dragStartX: 0, // 鼠标按下时的 X 坐标
      dragStartY: 0, // 鼠标按下时的 Y 坐标
      imageX: 0, // 图片的偏移量
      imageY: 0, // 图片的偏移量
    };
  },
  computed: {
    imageStyle() {
      return {
        transform: `scale(${this.scale}) translate(${this.imageX}px, ${this.imageY}px)`,
        transition: this.isDragging ? 'none' : 'transform 0.1s ease-out', // 拖动时禁用动画
        cursor: this.isDragging ? 'grabbing' : 'grab', // 拖动时更改鼠标样式
      };
    },
  },
  methods: {
    restore() {
      this.scale = 1;
      this.isDragging = false;
      this.dragStartX = 0;
      this.dragStartY = 0;
      this.imageX = 0;
      this.imageY = 0;
    },
    close() {
      this.restore();
      this.dialog.show = false
    },
    big() {
      this.scale = Math.min(this.scale * 1.5, 4); // 最大放大倍数
    },
    small() {
      this.scale = Math.max(this.scale / 1.5, 0.5); // 最小缩小倍数
    },
    // 鼠标按下开始拖动
    startDrag(event) {
      event.preventDefault();
      this.isDragging = true;
      this.dragStartX = event.clientX;
      this.dragStartY = event.clientY;
      document.addEventListener('mousemove', this.onDrag);
      document.addEventListener('mouseup', this.endDrag);
    },

    // 拖动过程中
    onDrag(event) {
      const dx = event.clientX - this.dragStartX; // 计算鼠标拖动的距离
      const dy = event.clientY - this.dragStartY;
      this.imageX += dx;
      this.imageY += dy;
      this.dragStartX = event.clientX; // 更新拖动开始的坐标
      this.dragStartY = event.clientY;
    },

    // 鼠标松开时结束拖动
    endDrag() {
      this.isDragging = false;
      document.removeEventListener('mousemove', this.onDrag);
      document.removeEventListener('mouseup', this.endDrag);
    },

    // 显示图片
    show(url) {
      if (url == null) this.$message.error('空文件无法预览');
      let temp = "";
      if (url.indexOf("https://thirdwx.qlogo.cn") !== -1) {
        this.dialog.url = url;
        this.dialog.show = true;
        return;
      }
      else temp = url.toLowerCase();
      if (temp.indexOf(".jpg") !== -1 || temp.indexOf(".jpeg") !== -1 || temp.indexOf(".png") !== -1) {
        this.dialog.url = temp;
        this.dialog.show = true;
      } else if (temp.indexOf(".txt") !== -1) {
        this.$axios.get(temp, { responseType: 'text' }).then(response => {
          const blob = new Blob([response.data], { type: 'text/plain; charset=UTF-8' });
          const blobUrl = URL.createObjectURL(blob);
          window.open(blobUrl, '_blank');
        })
      } else {
        // 其他类型文件或链接直接打开
        window.open(temp);
      }
    },
  },
};
</script>

<style scoped>
.el-image {
  object-fit: contain;
  transition: transform 0.2s ease;
  /* 平滑过渡 */
}
</style>
